import { QUERY_positionsPriceRanges } from 'queries';
import {
  PositionsPriceRangesQuery,
  PositionsPriceRangesQueryVariables,
  PositionDetails,
  TeamMemberCountQuery,
} from 'types/graphql';
import {
  ITeamMembersQueryProps,
  IPositionsPriceRangesQueryProps,
  PositionsPriceRangesType,
} from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.types';
import { QUERY_teamMembersCount } from 'queries';
import { castStringToInteger } from 'utils';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';

export const teamMembersQueryCountConfig = ({
  byFacilityId,
  byPositionId,
  onSuccess,
  byStartTime,
  byEndTime,
  allowOvertime,
  breakTime,
}: ITeamMembersQueryProps): UseGQLQueryConfig<
  TeamMemberCountQuery,
  number,
  {
    byPositionId: number;
    byFacilityId: number;
    byStartTime: string;
    byEndTime: string;
    allowOvertime?: boolean;
    breakTime?: string;
  }
> => ({
  key: 'CREATE_SHIFT_MODAL_REQUEST_TEAM',
  query: QUERY_teamMembersCount,
  responseTransformer: (data) => {
    return data?.requestJanes?.totalCount;
  },
  variables: {
    byPositionId: castStringToInteger(byPositionId[0]),
    byFacilityId,
    byStartTime,
    byEndTime,
    allowOvertime,
    breakTime,
  },
  onSuccess,
});

export const positionsPriceRangesQueryConfig = ({
  positionIds,
  communityId,
  onSuccess,
}: IPositionsPriceRangesQueryProps): UseGQLQueryConfig<
  PositionsPriceRangesQuery,
  PositionsPriceRangesType,
  PositionsPriceRangesQueryVariables
> => ({
  key: 'POSITION_PRICE_RANGE_QUERY',
  query: QUERY_positionsPriceRanges,
  responseTransformer: (data) => {
    if (!data) return data;
    if (data?.fetchPositions?.edges) {
      return data.fetchPositions.edges.reduce((acc, positionDetailsEdge) => {
        const positionDetails: PositionDetails | null =
          positionDetailsEdge?.node as PositionDetails | null;
        return {
          ...acc,
          ...(positionDetails?.id ? { [positionDetails.id]: positionDetails } : {}),
        };
      }, {});
    }
  },
  variables: {
    filter: {
      byId: positionIds.map((id) => castStringToInteger(id)),
    },
    communityId,
  },
  onSuccess,
});

export const fieldsThatAffectRequestedTeamMembers = ['position_id', 'quantity', 'allow_overtime'];
